import getRealDate from '@sdk/utils/getRealDate';
import { SUBSCRIPTION_LEVELS } from '@sdk/account/constants';
import { OrgSettingsFromApi } from '@sdk/authentication/types/apiTypes';
import { LaborCostCalculatorType } from '@sdk/common/types';
import { OrgSettings } from '@sdk/authentication/types/OrganisationType';
import type { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';

import { extendShiftTemplates } from './extendShiftTemplates';

const normalizeOrgSettings = (
  settings: OrgSettingsFromApi,
  personasDict: PersonasDict
): OrgSettings => {
  const normalizedSettings: any = { ...settings };

  'shiftTemplates' in normalizedSettings
    ? extendShiftTemplates(
        normalizedSettings.shiftTemplates,
        normalizedSettings.shiftBreakType,
        personasDict
      )
    : null;

  if (typeof normalizedSettings.overtimeWeekMultiplier === 'string') {
    normalizedSettings.overtimeWeekMultiplier = Number(
      normalizedSettings.overtimeWeekMultiplier.replace(',', '.')
    );
  }

  if (typeof normalizedSettings.spreadOfHoursPay === 'string') {
    normalizedSettings.spreadOfHoursPay = Number(
      normalizedSettings.spreadOfHoursPay.replace(',', '.')
    );
  }

  ['payrollPeriodStartDate', 'payrollPeriodStartDateTwo'].forEach((dateKey) => {
    if (typeof normalizedSettings[dateKey] === 'string') {
      normalizedSettings[dateKey] = getRealDate(normalizedSettings[dateKey]);
    }
  });

  if (normalizedSettings.firstDayOfWeek === 7) {
    normalizedSettings.firstDayOfWeek = 0;
  }

  if (!('laborCostCalculatorType' in normalizedSettings)) {
    normalizedSettings.laborCostCalculatorType = LaborCostCalculatorType.us;
  }

  // TODO to be removed?
  // fallback to work with older server
  if (!('premiumTrialLength' in normalizedSettings)) {
    normalizedSettings.premiumTrialLength = 30;
  }

  if (normalizedSettings.laborCostCalculatorType === LaborCostCalculatorType.iceland) {
    /**
     * Server should marshal it as true but we can't make this change there without breaking
     * compatibility with current clients. So we need this hack first and then when server
     * marshalls it as true we can remove this if.
     */
    normalizedSettings.holidaysEnabled = true;
  }

  if (normalizedSettings.premiumFeatures) {
    normalizedSettings.premiumFeatures.shiftsBulkEdit = SUBSCRIPTION_LEVELS.PREMIUM;
  }

  return normalizedSettings;
};

export default normalizeOrgSettings;
